




















































































import { FormInput, Select, Textarea } from '@/pages/profile/blocks';
import { Checkbox } from '@/components/form';
import { validationMixin } from 'vuelidate';
import { Button } from '@/pages/profile/components';
import { Message } from '../settings/components';
import { SettingsMixin } from '../../mixins';
import { _util } from '@/tools/declare/global/$util';

import AppSvgIcon from '@/uikit/components/AppSvgIconNew/AppSvgIcon.vue';
import { url } from 'vuelidate/lib/validators';

export default {
  name: 'Additional',
  components: {
    AppSvgIcon,
    FormInput,
    Checkbox,
    Textarea,
    Message,
    Select,
    Button,
  },
  mixins: [validationMixin, SettingsMixin],
  props: {
    text: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      about_me: '',
      key_skills: '',
      is_car: false,
      site: '',
      drivers_license: [],
      native_language: '',
      foreign_language: [{ language: '', level: '' }],
    };
  },
  computed: {
    driverLicenseDict() {
      return this.$store.state.driverLicenseDict.map((el: any) => ({
        text: el.name,
        value: el.id,
      }));
    },

    worldLanguageDict() {
      return this.$store.state.worldLanguageDict.map((el: any) => ({
        text: el.name,
        value: el.id,
      }));
    },

    languageLevelDict() {
      return this.$store.state.languageLevelDict.map((el: any) => ({
        text: el.name,
        value: el.id,
      }));
    },
  },
  validations: {
    site: {
      url,
    },
  },
  created() {
    this.initData();
  },
  watch: {
    profile() {
      this.initData();
    },
  },
  methods: {
    initData() {
      const {
        about_me,
        key_skills,
        is_car,
        site,
        drivers_license,
        native_language,
        foreign_language,
      } = this.profile;
      this.$set(this, 'about_me', about_me || '');
      this.$set(this, 'key_skills', key_skills || '');
      this.$set(this, 'is_car', is_car || false);
      this.$set(this, 'site', site || '');
      this.$set(this, 'drivers_license', drivers_license || []);
      this.$set(this, 'native_language', native_language || '');
      this.$set(
        this,
        'foreign_language',
        foreign_language?.length
          ? foreign_language
          : [{ language: '', level: '' }]
      );
    },
    appendLanguage() {
      this.foreign_language.push({ language: '', level: '' });
    },
    removeLanguage(index: number) {
      const attrs: Array<number | any> = [index, 1];
      if (this.foreign_language?.length <= 1 && index == 0)
        attrs.push({ language: '', level: '' });
      this.foreign_language.splice(...attrs);
    },
    accumulateData() {
      const {
        about_me,
        key_skills,
        is_car,
        site,
        drivers_license,
        native_language,
        foreign_language,
      } = this;
      return {
        about_me,
        key_skills,
        is_car,
        site,
        drivers_license,
        native_language,
        foreign_language,
      };
    },
    validate() {
      this.$v.$touch();
      return this.$v.$invalid;
    },
    async saveProfile() {
      const isValid = this.validate();
      if (!isValid) {
        const additionalData = this.accumulateData();
        if (
          this.foreign_language?.length <= 1 &&
          !this.foreign_language[0].language &&
          !this.foreign_language[0].level
        )
          additionalData.foreign_language = [];
        try {
          this.$emit('submitUser', additionalData);
        } catch (e) {
          this.isServerReqError = true;
          throw e;
        }
      }
    },
    reset() {
      this.initData();
    },
  },
};



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/views/additional/Addittional.vue